export const BOTTOM_DROPDOWN_OFFSET_PIXELS = 16;
